package example.shadcn_kotlin.ui.pages.docs.components.alert_dialog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.AlertDialogDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/alert-dialog/index.md", mapOf("title" to listOf("Alert Dialog"), "description" to listOf("A modal dialog that interrupts the user with important content and expects a response."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/alert-dialog"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/alert-dialog#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import radix_ui.components.AlertDialogProps
import react.FC
import shadcn.ui.components.*

val AlertDialogDemo = FC<AlertDialogProps> {
    AlertDialog {
        AlertDialogTrigger {
            asChild = true
            Button {
                variant ="outline"
                +"Show Dialog"
            }
        }
        AlertDialogContent {
            AlertDialogHeader {
                AlertDialogTitle {
                    +"Are you absolutely sure?"
                }
                AlertDialogDescription {
                    +"This action cannot be undone. This will permanently delete your "
                    +"account and remove your data from our servers."
                }
            }
            AlertDialogFooter {
                AlertDialogCancel {
                    +"Cancel"
                }
                AlertDialogAction {
                    +"Continue"
                }
            }
        }
    }
}"""){ 
 AlertDialogDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.AlertDialog
import shadcn.ui.components.AlertDialogContent
import shadcn.ui.components.AlertDialogHeader
import shadcn.ui.components.AlertDialogTrigger
import shadcn.ui.components.AlertDialogTitle
import shadcn.ui.components.AlertDialogDescription
import shadcn.ui.components.AlertDialogFooter
import shadcn.ui.components.AlertDialogCancel
import shadcn.ui.components.AlertDialogAction
""", lang= "kotlin", highlight= "")
            CodeBlock("""AlertDialog {
    AlertDialogTrigger { +"Show Dialog" }
    AlertDialogContent {
        AlertDialogHeader {
            AlertDialogTitle { +"Are you absolutely sure?" }
            AlertDialogDescription {
                +"This action cannot be undone. This will permanently delete your "
                +"account and remove your data from our servers."
            }
        }
        AlertDialogFooter {
            AlertDialogCancel { +"Cancel" }
            AlertDialogAction { +"Continue" }
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
